import { render, staticRenderFns } from "./all-shop.vue?vue&type=template&id=bf5476c2&scoped=true"
import script from "./all-shop.vue?vue&type=script&lang=js"
export * from "./all-shop.vue?vue&type=script&lang=js"
import style0 from "./all-shop.vue?vue&type=style&index=0&id=bf5476c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5476c2",
  null
  
)

export default component.exports